import { Vue } from 'vue-class-component';
import useSecurityStore from '@/store/security';
import MatomoDashboard from './matomo-dashboard/matomo-dashboard';
import PublicDashboard from './public-dashboard/public-dashboard';

export default class Dashboard extends Vue {
  get isPublicApp() {
    return useSecurityStore().isPublicApplication;
  }

  render() {
    return this.isPublicApp ? <PublicDashboard /> : <MatomoDashboard />;
  }
}
